import {QuestionaryType} from '../../_types/selectOptionsTypes/QuestionaryTypes';

export const questionaryOptions: Array<QuestionaryType> = [
  {value: 'UNSET', label: 'Unset'},
  {value: 'YES', label: 'Yes'},
  {value: 'NO', label: 'No'},
];
